var exports = {
  "dc": "ReferralSettingsTab.module__spinnerContainer___YVk5eG",
  "Zp": "ReferralSettingsTab.module__layout___YVk5eG",
  "M1": "ReferralSettingsTab.module__stats___YVk5eG",
  "dJ": "ReferralSettingsTab.module__stat___YVk5eG",
  "cR": "ReferralSettingsTab.module__statValue___YVk5eG",
  "Zh": "ReferralSettingsTab.module__statLabel___YVk5eG",
  "p_": "ReferralSettingsTab.module__list___YVk5eG",
  "nM": "ReferralSettingsTab.module__row___YVk5eG",
  "uV": "ReferralSettingsTab.module__rowHeader___YVk5eG",
  "G9": "ReferralSettingsTab.module__rowTitle___YVk5eG",
  "en": "ReferralSettingsTab.module__rowMeta___YVk5eG",
  "h3": "ReferralSettingsTab.module__rowReached___YVk5eG",
  "M0": "ReferralSettingsTab.module__bar___YVk5eG",
  "pP": "ReferralSettingsTab.module__barFill___YVk5eG",
  "Ie": "ReferralSettingsTab.module__empty___YVk5eG",
};

module.exports = exports;
